// window.__cantaria_cart_state__ = {
//   hasSubscription: false,
//   cartToken: null,
//   updatedAt: 0,
// };

// window.cantariaGetCart = async function () {
//   const res = await fetch('/cart.js', { credentials: 'same-origin' });
//   if (!res.ok) throw new Error('Cantaria: /cart.js failed');
//   return res.json();
// };

// window.cantariaCartHasSubscription = function (cart) {
//   if (!cart || !Array.isArray(cart.items)) return false;
//   return cart.items.some(it => !!it?.selling_plan_allocation);
// };

// window.cantariaRefreshCartState = async function () {
//   const cart = await window.cantariaGetCart();
//   const hasSub = window.cantariaCartHasSubscription(cart);

//   window.__cantaria_cart_state__ = {
//     hasSubscription: hasSub,
//     cartToken: cart.token || null,
//     updatedAt: Date.now(),
//   };

//   console.log('[Cantaria] hasSubscription =', hasSub);

//   return { cart, hasSub };
// };

// window.cantariaWatchCartDrawer = function (drawerSelector = '#CartDrawer') {
//   const drawer = document.querySelector(drawerSelector);
//   if (!drawer) return;

//   let t = null;
//   const obs = new MutationObserver(() => {
//     clearTimeout(t);
//     t = setTimeout(() => {
//       window.cantariaRefreshCartState().catch(() => {});
//     }, 120);
//   });

//   obs.observe(drawer, { childList: true, subtree: true });
// };

// document.addEventListener('DOMContentLoaded', () => {
//   window.cantariaWatchCartDrawer('#CartDrawer');
// });
// // =============================
// // Cantaria — Huilier upsell: force Member/Regular + 250/500 based on cart
// // =============================
// const CANTARIA_HUILIER_VARIANTS = {
//   "250": { regular: 63258420216157, member: 63546742571357 },
//   "500": { regular: 63258420248925, member: 63546742604125 },
// };

// // (évite double-ajout si le drawer rerender et que le user reclique vite)
// window.__cantaria_huilier_add_lock__ = false;

// // Déduire 250/500 depuis l’item abonnement présent au panier (source de vérité)
// function cantariaInferFormatFromCart(cart) {
//   if (!cart?.items?.length) return "250";

//   const subItem = cart.items.find(it => !!it?.selling_plan_allocation);
//   if (!subItem) return "250";

//   const hay = [
//     subItem.variant_title,
//     subItem.product_title,
//     ...(Array.isArray(subItem.variant_options) ? subItem.variant_options : []),
//   ]
//     .filter(Boolean)
//     .join(" ")
//     .toLowerCase();

//   if (hay.includes("500")) return "500";
//   if (hay.includes("250")) return "250";

//   return "250";
// }

// // Ajout via /cart/add.js
// async function cantariaAddVariantToCart(variantId, qty = 1) {
//   const res = await fetch("/cart/add.js", {
//     method: "POST",
//     headers: { "Content-Type": "application/json", Accept: "application/json" },
//     credentials: "same-origin",
//     body: JSON.stringify({ id: variantId, quantity: qty }),
//   });
//   if (!res.ok) {
//     const txt = await res.text().catch(() => "");
//     throw new Error("Cantaria: /cart/add.js failed: " + txt);
//   }
//   return res.json();
// }

// // Interception "en capture" pour bloquer le quick-add du thème AVANT qu'il ne s'exécute
// document.addEventListener(
//   "click",
//   async (e) => {
//     const btn = e.target.closest("button");
//     if (!btn) return;

//     // on cible le bloc upsell "Huilier Cantaria" vu dans ton drawer
//     const card = btn.closest(".rounded-storefront-drawer");
//     if (!card) return;

//     const isHuilier = (card.innerText || "").toLowerCase().includes("huilier cantaria");
//     const isAjouter = (btn.innerText || "").trim().toLowerCase() === "ajouter";
//     if (!isHuilier || !isAjouter) return;

//     // BLOQUE le comportement du thème (quick add / modal options)
//     e.preventDefault();
//     e.stopPropagation();
//     if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

//     if (window.__cantaria_huilier_add_lock__) return;
//     window.__cantaria_huilier_add_lock__ = true;

//     try {
//       const { cart, hasSub } = await window.cantariaRefreshCartState();
//       const format = cantariaInferFormatFromCart(cart); // "250" | "500"
//       const picked = hasSub
//         ? CANTARIA_HUILIER_VARIANTS[format].member
//         : CANTARIA_HUILIER_VARIANTS[format].regular;

//       console.log("[Cantaria] Huilier upsell:", { hasSub, format, picked });

//       await cantariaAddVariantToCart(picked, 1);

//       // petit signal générique (au cas où ton thème écoute)
//       document.dispatchEvent(new CustomEvent("cart:updated"));
//       document.dispatchEvent(new CustomEvent("cantaria:cart-updated"));
//     } catch (err) {
//       console.error(err);
//     } finally {
//       window.__cantaria_huilier_add_lock__ = false;
//     }
//   },
//   true // <-- CAPTURE = crucial
// );
// // =============================
// // Cantaria — Force huilier variant at the network layer (most robust)
// // =============================
// (function cantariaPatchCartAdd() {
//   if (window.__cantaria_patch_cart_add__) return;
//   window.__cantaria_patch_cart_add__ = true;

//   const origFetch = window.fetch;

//   function isCartAddUrl(input) {
//     const url = typeof input === "string" ? input : (input && input.url) || "";
//     return url.includes("/cart/add");
//   }

//   function extractIdFromBody(body) {
//     try {
//       if (!body) return null;

//       // body can be stringified JSON
//       if (typeof body === "string") {
//         const s = body.trim();

//         // JSON
//         if (s.startsWith("{")) {
//           const obj = JSON.parse(s);
//           return obj?.id ? Number(obj.id) : null;
//         }

//         // form-encoded id=...
//         const params = new URLSearchParams(s);
//         if (params.has("id")) return Number(params.get("id"));
//       }

//       // body can be FormData
//       if (body instanceof FormData) {
//         const v = body.get("id");
//         return v ? Number(v) : null;
//       }

//       // body can be URLSearchParams
//       if (body instanceof URLSearchParams) {
//         const v = body.get("id");
//         return v ? Number(v) : null;
//       }

//       // body can be object (rare)
//       if (typeof body === "object") {
//         return body?.id ? Number(body.id) : null;
//       }
//     } catch (_) {}
//     return null;
//   }

//   function replaceIdInBody(body, newId) {
//     // Return a new body that mirrors the original format
//     if (!body) return JSON.stringify({ id: newId, quantity: 1 });

//     if (typeof body === "string") {
//       const s = body.trim();
//       if (s.startsWith("{")) {
//         const obj = JSON.parse(s);
//         obj.id = newId;
//         return JSON.stringify(obj);
//       }
//       const params = new URLSearchParams(s);
//       params.set("id", String(newId));
//       return params.toString();
//     }

//     if (body instanceof FormData) {
//       const fd = new FormData();
//       for (const [k, v] of body.entries()) fd.append(k, v);
//       fd.set("id", String(newId));
//       return fd;
//     }

//     if (body instanceof URLSearchParams) {
//       const p = new URLSearchParams(body.toString());
//       p.set("id", String(newId));
//       return p;
//     }

//     if (typeof body === "object") {
//       return { ...body, id: newId };
//     }

//     return body;
//   }

//   // Determine if the id belongs to any huilier variant (regular/member 250/500)
//   const ALL_HUILIER_IDS = new Set([
//     63258420216157, 63546742571357, 63258420248925, 63546742604125,
//   ]);

//   window.fetch = async function (input, init) {
//     try {
//       if (isCartAddUrl(input) && init && init.method && init.method.toUpperCase() === "POST") {
//         const body = init.body;
//         const id = extractIdFromBody(body);

//         if (id && ALL_HUILIER_IDS.has(id)) {
//           const { cart, hasSub } = await window.cantariaRefreshCartState();
//           const format = cantariaInferFormatFromCart(cart); // "250"/"500"
//           const forced = hasSub
//             ? CANTARIA_HUILIER_VARIANTS[format].member
//             : CANTARIA_HUILIER_VARIANTS[format].regular;

//           if (forced !== id) {
//             if (window.__cantaria_huilier_upsell_guard__) {
//               console.log("[Cantaria] cart/add patch: replace", id, "->", forced, { hasSub, format });
//             }
//             init = { ...init, body: replaceIdInBody(body, forced) };
//           }
//         }
//       }
//     } catch (e) {
//       // Never break cart add if our logic fails
//       console.warn("[Cantaria] cart/add patch error", e);
//     }
//     return origFetch(input, init);
//   };
// })();




/* second working code */

// /**
//  * Cantaria — Huilier Upsell UI Logic (Ultra-Robust JS + Fix)
//  * Handles button interactions and UI state for custom upsell blocks.
//  * Patches custom PDP buttons (.pdp-atc-btn) and club buttons.
//  */

// (function () {
//   const CLUB_PRODUCT_IDS = [
//     15962089619805, 15962069827933, 15962048594269, 15955956695389,
//     15910818775389, 15910818152797, 15908234527069, 15908233511261,
//     15734454092125, 15728565682525
//   ];
//   const DISPENSER_PRODUCT_ID = 15889565647197;

//   /**
//    * Updates state of all upsell UI components.
//    */
//   async function updateUpsellUI() {
//     try {
//       const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
//       const cart = await res.json();

//       const items = cart.items || [];
//       const hasClub = items.some(it => CLUB_PRODUCT_IDS.includes(Number(it.product_id)) || !!it.selling_plan_allocation);
//       const hasDispenser = items.some(it => Number(it.product_id) === DISPENSER_PRODUCT_ID);

//       const drawer = document.querySelector('#ooc-drawer-upsell');
//       if (drawer instanceof HTMLElement) {
//         drawer.dataset.hasClub = String(hasClub);
//         drawer.dataset.hasDispenser = String(hasDispenser);
//         if (hasClub && hasDispenser) {
//           drawer.classList.add('ooc-hidden');
//         } else {
//           drawer.classList.remove('ooc-hidden');
//           drawer.classList.toggle('state-add-product', !hasDispenser);
//           drawer.classList.toggle('state-add-club', hasDispenser);
//         }
//       }

//       document.querySelectorAll('.ooc-upsell-container').forEach(el => {
//         el.classList.toggle('is-member', hasClub);
//       });
//     } catch (e) {
//       console.error('[Cantaria] UI Sync Error', e);
//     }
//   }

//   /**
//    * Helper: AJAX Add to cart for custom buttons.
//    * @param {string|number} variantId 
//    * @param {number} quantity 
//    * @param {Element|null} button 
//    * @param {string|null} sellingPlanId 
//    * @param {boolean} skipDrawer 
//    */
//   async function addToCart(variantId, quantity = 1, button = null, sellingPlanId = null, skipDrawer = false) {
//     if (!variantId) {
//       console.error('[Cantaria] Cannot add to cart: Missing variantId');
//       return;
//     }

//     console.log('[Cantaria] Requesting Add to Cart:', { variantId, quantity, sellingPlanId, skipDrawer });

//     const btn = (button instanceof HTMLElement) ? button : null;

//     if (btn) {
//       const originalText = btn.getAttribute('data-original-text') || btn.innerHTML;
//       if (!btn.getAttribute('data-original-text')) {
//         btn.setAttribute('data-original-text', originalText);
//       }
//       btn.innerHTML = "Adding...";
//       btn.disabled = true;
//     }

//     try {
//       // Create a plain object for JSON submission
//       const bodyObj = {
//         id: String(variantId),
//         quantity: parseInt(String(quantity))
//       };

//       if (sellingPlanId && sellingPlanId !== "null" && sellingPlanId !== "undefined" && sellingPlanId !== "") {
//         bodyObj['selling_plan'] = String(sellingPlanId);
//       }

//       // Detect sections to refresh (Common in Shopify themes for drawer updates)
//       const cartItemsComponents = document.querySelectorAll('cart-items-component');
//       let sectionIds = [];
//       cartItemsComponents.forEach((item) => {
//         if (item instanceof HTMLElement && item.dataset.sectionId) {
//           sectionIds.push(item.dataset.sectionId);
//         }
//       });
//       if (sectionIds.length) {
//         bodyObj['sections'] = sectionIds.join(',');
//       }

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify(bodyObj)
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         console.error('[Cantaria] API Error:', data);
//         throw new Error(data.description || data.message || `Error ${response.status}`);
//       }

//       console.log('[Cantaria] Successfully added to cart:', data);

//       // Dispatch event to update the cart UI components
//       document.documentElement.dispatchEvent(new CustomEvent('cart:update', {
//         bubbles: true,
//         detail: {
//           sourceId: 'upsell-add',
//           variantId: variantId,
//           quantity: quantity,
//           skipDrawer: skipDrawer,
//           resource: data,
//           data: { sections: data.sections, itemCount: data.item_count, source: 'upsell' }
//         }
//       }));

//       // Trigger legacy theme events
//       document.dispatchEvent(new CustomEvent('cart:updated'));
//       await updateUpsellUI();

//     } catch (error) {
//       console.error('[Cantaria] Cart Add Failed:', error);
//       alert('Add to cart failed: ' + (error instanceof Error ? error.message : String(error)));
//     } finally {
//       if (btn) {
//         btn.innerHTML = btn.getAttribute('data-original-text') || "ADD";
//         btn.disabled = false;
//       }
//     }
//   }

//   /**
//    * Central Click Listener
//    */
//   document.addEventListener("click", async (e) => {
//     const target = e.target;
//     if (!(target instanceof Element)) return;

//     // Detect clickable buttons using more robust class list
//     const customBtn = target.closest('.ooc-proposal-add-all-btn, .ooc-proposal-btn, .pdp-atc-btn, .ooc-upsell-add-btn, .ooc-drawer-add-btn');
//     if (!customBtn || !(customBtn instanceof HTMLElement)) return;

//     const drawer = document.querySelector('#ooc-drawer-upsell');
//     const isMember = (drawer instanceof HTMLElement && drawer.dataset.hasClub === 'true');

//     let vId = null;
//     let sId = null;
//     let skip = false;

//     // 1. "Join the Club" Button Logic
//     if (customBtn.classList.contains('ooc-proposal-add-all-btn')) {
//       e.preventDefault();
//       e.stopPropagation();

//       const container = customBtn.closest('.ooc-drawer-proposal');
//       const selected = container ? container.querySelector('input[name="ooc-club-choice"]:checked') : null;

//       if (selected instanceof HTMLInputElement) {
//         vId = selected.value;
//         sId = selected.getAttribute('data-selling-plan');
//       } else {
//         // Fallback to button's own data if radio is missing/unchecked
//         vId = customBtn.getAttribute('data-variant-id');
//         sId = customBtn.getAttribute('data-selling-plan');
//       }
//     }
//     // 2. Custom PDP Add to Cart Button Logic
//     else if (customBtn.classList.contains('pdp-atc-btn')) {
//       const form = customBtn.closest('form');
//       vId = customBtn.getAttribute('data-product-id') || customBtn.getAttribute('data-variant-id');
//       sId = customBtn.getAttribute('data-selling-plan');

//       if (!vId && form instanceof HTMLFormElement) {
//         const idInput = form.querySelector('[name="id"]');
//         if (idInput instanceof HTMLInputElement || idInput instanceof HTMLSelectElement) {
//           vId = idInput.value;
//         }
//         const spInput = form.querySelector('[name="selling_plan"]');
//         if (spInput instanceof HTMLInputElement || spInput instanceof HTMLSelectElement) {
//           sId = sId || spInput.value;
//         }
//       }

//       if (vId) {
//         e.preventDefault();
//         e.stopPropagation();
//         skip = true;
//       } else {
//         return; // Allow default behavior if we can't find a variant ID
//       }
//     }
//     // 3. Ceramic Bottle Member/Regular Logic
//     else if (customBtn.hasAttribute('data-member-id') && customBtn.hasAttribute('data-regular-id')) {
//       e.preventDefault();
//       e.stopPropagation();
//       vId = isMember ? customBtn.getAttribute('data-member-id') : customBtn.getAttribute('data-regular-id');
//       sId = customBtn.getAttribute('data-selling-plan');
//     }
//     // 4. Other Standard Fallbacks
//     else {
//       vId = customBtn.getAttribute('data-product-id') || customBtn.getAttribute('data-club-id') || customBtn.getAttribute('data-variant-id');
//       sId = customBtn.getAttribute('data-selling-plan');
//       if (vId) {
//         e.preventDefault();
//         e.stopPropagation();
//       }
//     }

//     if (vId) {
//       await addToCart(vId, 1, customBtn, sId, skip);
//     }
//   }, true);

//   /**
//    * Sync Join Button data attributes when radio selection changes
//    */
//   document.addEventListener('change', (e) => {
//     const target = e.target;
//     if (target instanceof HTMLInputElement && target.name === 'ooc-club-choice') {
//       const container = target.closest('.ooc-drawer-proposal');
//       const btn = container ? container.querySelector('.ooc-proposal-add-all-btn') : null;
//       if (btn instanceof HTMLElement) {
//         btn.setAttribute('data-variant-id', target.value);
//         btn.setAttribute('data-selling-plan', target.getAttribute('data-selling-plan') || '');
//       }
//     }
//   });

//   // Initial Sync
//   document.addEventListener('DOMContentLoaded', updateUpsellUI);
//   document.addEventListener('cart:updated', updateUpsellUI);
//   window.addEventListener('load', updateUpsellUI);
// })();



// /**
//  * Cantaria — Huilier Upsell UI Logic (Ultra-Robust AJAX)
//  * Handles button interactions, bundling, and atomic cart additions.
//  */

// (function () {
//   // IDs for Club products (subscriptions)
//   const CLUB_IDS = [
//     62474984161629, 62474984227165, 15962089619805, 15962069827933,
//     15962048594269, 15955956695389, 15910818775389, 15910818152797,
//     15908234527069, 15908233511261, 15734454092125, 15728565682525
//   ];

//   let isProcessingGlobal = false;

//   /**
//    * Sync UI state based on fresh cart data.
//    */
//   async function updateUpsellUI() {
//     try {
//       const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
//       const cart = await res.json();
//       const items = cart.items || [];

//       const hasClub = items.some(it =>
//         CLUB_IDS.includes(Number(it.variant_id)) ||
//         CLUB_IDS.includes(Number(it.id)) ||
//         CLUB_IDS.includes(Number(it.product_id)) ||
//         !!it.selling_plan_allocation
//       );

//       const drawer = document.querySelector('#ooc-drawer-upsell');
//       if (drawer instanceof HTMLElement) {
//         const dispenserId = String(drawer.dataset.productId);
//         const hasDispenser = items.some(it => {
//           const pid = String(it.product_id);
//           const handle = (it.handle || '').toLowerCase();
//           const title = (it.title || '').toLowerCase();
//           return pid === dispenserId ||
//             handle.includes('huilier') ||
//             handle.includes('oil-mill') ||
//             title.includes('huilier') ||
//             title.includes('bottle');
//         });

//         drawer.dataset.hasClub = String(hasClub);
//         drawer.dataset.hasDispenser = String(hasDispenser);

//         if (hasClub && hasDispenser) {
//           drawer.classList.add('ooc-hidden');
//         } else {
//           drawer.classList.remove('ooc-hidden');
//           drawer.classList.toggle('state-add-product', !hasDispenser);
//           drawer.classList.toggle('state-add-club', hasDispenser && !hasClub);
//         }
//       }

//       document.querySelectorAll('.ooc-upsell-container').forEach(el => {
//         el.classList.toggle('is-member', hasClub);
//       });
//     } catch (e) {
//       console.warn('[Cantaria] UI Sync Warning:', e);
//     }
//   }

//   /**
//    * Final Atomic ADD Logic
//    */
//   async function performAdd(itemsToAdd, button) {
//     if (!itemsToAdd || itemsToAdd.length === 0) return;

//     if (button instanceof HTMLElement) {
//       button.setAttribute('data-original-html', button.innerHTML);
//       button.innerHTML = "Adding...";
//       if (button instanceof HTMLButtonElement) button.disabled = true;
//     }

//     try {
//       // Find all sections that might need updating to ensure smooth AJAX update
//       const sectionsToUpdate = [];
//       document.querySelectorAll('[data-section-id]').forEach(el => {
//         const sid = el.dataset.sectionId;
//         const sType = el.getAttribute('data-section-type') || '';
//         // Prioritize cart-drawer and cart-items
//         if (sid && !sectionsToUpdate.includes(sid)) sectionsToUpdate.push(sid);
//       });

//       // CLEAN BODY: Ensure only valid variants are sent
//       const cleanedItems = itemsToAdd
//         .filter(it => it.id && String(it.id) !== "null" && String(it.id) !== "" && String(it.id) !== "undefined")
//         .map(it => {
//           const item = { id: String(it.id), quantity: parseInt(it.quantity) || 1 };
//           if (it.selling_plan && String(it.selling_plan) !== "null" && String(it.selling_plan) !== "" && String(it.selling_plan) !== "undefined") {
//             item.selling_plan = String(it.selling_plan).trim();
//           }
//           return item;
//         });

//       if (cleanedItems.length === 0) throw new Error('No valid variants to add.');

//       const bodyData = {
//         items: cleanedItems,
//         sections: sectionsToUpdate.join(','),
//         sections_url: window.location.pathname
//       };

//       console.log('[Cantaria] Posting to Cart (AJAX):', bodyData);

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify(bodyData)
//       });

//       const data = await response.json();
//       if (!response.ok) {
//         console.error('[Cantaria] Shopify reject:', data);
//         throw new Error(data.description || data.message || `Shopify error ${response.status}`);
//       }

//       // Sync Theme State
//       const eventDetail = {
//         bubbles: true,
//         detail: {
//           resource: data,
//           sourceId: 'upsell-add',
//           data: {
//             source: 'product-form-component',
//             itemCount: data.item_count,
//             sections: data.sections,
//             productId: cleanedItems[0].id
//           }
//         }
//       };

//       // Dispatch events to refresh the UI
//       document.dispatchEvent(new CustomEvent('cart:update', eventDetail));
//       document.dispatchEvent(new CustomEvent('cart:updated'));

//       // EXPLICIT FORCE OPEN: Ensure the drawer stays/is open after addition
//       const cartDrawer = document.querySelector('cart-drawer-component');
//       if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
//         cartDrawer.showDialog();
//       }

//       await updateUpsellUI();

//     } catch (error) {
//       console.error('[Cantaria] Bundle Add Failed:', error);
//     } finally {
//       if (button instanceof HTMLElement) {
//         button.innerHTML = button.getAttribute('data-original-html') || "ADD";
//         if (button instanceof HTMLButtonElement) button.disabled = false;
//       }
//     }
//   }

//   /**
//    * Main Click Interceptor (CAPTURE PHASE)
//    */
//   document.addEventListener("click", async (e) => {
//     const target = e.target;
//     if (!(target instanceof Element)) return;

//     const customBtn = target.closest('.ooc-drawer-add-btn, .ooc-upsell-add-btn');
//     if (!customBtn || isProcessingGlobal) return;

//     // PREVENT: Stop ANY other script (theme default or legacy) from refreshing the page!
//     e.preventDefault();
//     e.stopPropagation();
//     if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

//     isProcessingGlobal = true;
//     if (customBtn instanceof HTMLButtonElement) customBtn.disabled = true;

//     try {
//       // 1. Refresh fresh cart state
//       const cartRes = await fetch('/cart.js', { cache: 'no-store' });
//       const cart = await cartRes.json();
//       const currentItems = cart.items || [];

//       const drawer = document.querySelector('#ooc-drawer-upsell');
//       const dispenserId = drawer instanceof HTMLElement ? String(drawer.dataset.productId) : "";

//       const dispenserInCart = currentItems.find((it) => {
//         const pid = String(it.product_id);
//         const handle = (it.handle || '').toLowerCase();
//         const title = (it.title || '').toLowerCase();
//         return pid === dispenserId ||
//           handle.includes('huilier') ||
//           handle.includes('oil-mill') ||
//           title.includes('huilier') ||
//           title.includes('bottle');
//       });

//       const isMember = currentItems.some((it) =>
//         CLUB_IDS.includes(Number(it.variant_id)) ||
//         CLUB_IDS.includes(Number(it.id)) ||
//         CLUB_IDS.includes(Number(it.product_id)) ||
//         !!it.selling_plan_allocation
//       );

//       const itemsToRequest = [];
//       let willAddSubscription = false;

//       // BUNDLING: Add main product subscription if missing
//       if (!isMember) {
//         const mainVId = customBtn.getAttribute('data-main-variant-id');
//         const mainSId = customBtn.getAttribute('data-main-selling-plan');
//         if (mainVId && String(mainVId) !== "null" && String(mainVId) !== "") {
//           itemsToRequest.push({ id: mainVId, quantity: 1, selling_plan: mainSId });
//           willAddSubscription = true;
//         }
//       }

//       // BOTTLE: Handle addition or member-price upgrade
//       const regularId = customBtn.getAttribute('data-regular-id');
//       const memberId = customBtn.getAttribute('data-member-id');

//       if (!dispenserInCart) {
//         // CASE: Bottle is NOT in cart -> Add correct variant
//         const variantId = (isMember || willAddSubscription) ? memberId : regularId;
//         if (variantId && String(variantId) !== "null" && String(variantId) !== "") {
//           itemsToRequest.push({ id: variantId, quantity: 1 });
//         }
//       }

//       if (itemsToRequest.length > 0) {
//         await performAdd(itemsToRequest, customBtn);
//       } else {
//         // Just open the drawer if already present
//         const cartDrawer = document.querySelector('cart-drawer-component');
//         if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
//           cartDrawer.showDialog();
//         }
//         await updateUpsellUI();
//       }

//     } finally {
//       isProcessingGlobal = false;
//       if (customBtn instanceof HTMLButtonElement) customBtn.disabled = false;
//     }
//   }, true);

//   document.addEventListener('DOMContentLoaded', updateUpsellUI);
//   document.addEventListener('cart:updated', updateUpsellUI);
//   window.addEventListener('load', updateUpsellUI);
// })();

// /**
//  * Cantaria — Huilier Upsell UI Logic
//  * Handles bundling of the Ceramic Bottle and Main Subscription product.
//  * Optimized for AJAX cart updates and multiple additions.
//  */

// (function () {
//   const CLUB_IDS = [
//     62474984161629, 62474984227165, 15962089619805, 15962069827933,
//     15962048594269, 15955956695389, 15910818775389, 15910818152797,
//     15908234527069, 15908233511261, 15734454092125, 15728565682525
//   ];

//   let isProcessing = false;

//   /**
//    * Refresh the upsell UI state (hidden/visible classes).
//    */
//   async function updateUpsellUI() {
//     try {
//       const res = await fetch('/cart.js', { cache: 'no-store' });
//       const cart = await res.json();
//       const items = cart.items || [];

//       const hasClub = items.some(it =>
//         CLUB_IDS.includes(Number(it.variant_id)) ||
//         CLUB_IDS.includes(Number(it.id)) ||
//         !!it.selling_plan_allocation
//       );

//       const drawer = document.querySelector('#ooc-drawer-upsell');
//       if (drawer) {
//         const hasBottle = items.some(it => (it.handle || '').includes('huilier') || (it.title || '').toLowerCase().includes('bottle'));

//         drawer.dataset.hasClub = String(hasClub);
//         drawer.dataset.hasDispenser = String(hasBottle);

//         if (hasClub && hasBottle) {
//           drawer.classList.add('ooc-hidden');
//         } else {
//           drawer.classList.remove('ooc-hidden');
//           drawer.classList.toggle('state-add-product', !hasBottle);
//           drawer.classList.toggle('state-add-club', hasBottle && !hasClub);
//         }
//       }

//       document.querySelectorAll('.ooc-upsell-container').forEach(el => {
//         el.classList.toggle('is-member', hasClub);
//       });
//     } catch (e) {
//       console.warn('[Cantaria] UI Sync Error:', e);
//     }
//   }

//   /**
//    * Perform the AJAX addition to the cart and update the drawer.
//    */
//   async function performAdd(itemsToAdd, button) {
//     if (itemsToAdd.length === 0) return;

//     try {
//       if (button) {
//         button.dataset.originalHtml = button.innerHTML;
//         button.innerHTML = "Adding...";
//         if (button instanceof HTMLButtonElement) button.disabled = true;
//       }

//       // Collect all sections that might need refreshing (drawer, count, etc)
//       const sections = Array.from(document.querySelectorAll('[data-section-id]'))
//         .map(el => el.dataset.sectionId)
//         .filter(Boolean)
//         .join(',');

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           items: itemsToAdd,
//           sections: sections,
//           sections_url: window.location.pathname
//         })
//       });

//       const data = await response.json();

//       if (!response.ok) throw new Error(data.message || 'Cart Add Failed');

//       // Dispatch native theme events to refresh the UI and Open Drawer
//       const eventDetail = {
//         bubbles: true,
//         detail: {
//           data: { sections: data.sections },
//           itemCount: data.item_count,
//           source: 'product-form-component'
//         }
//       };

//       document.dispatchEvent(new CustomEvent('cart:update', eventDetail));
//       document.dispatchEvent(new CustomEvent('cart:updated'));

//       // Explicitly show the cart drawer
//       const cartDrawer = document.querySelector('cart-drawer-component');
//       if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
//         cartDrawer.showDialog();
//       }

//       await updateUpsellUI();
//     } catch (error) {
//       console.error('[Cantaria] Upsell Add Failed:', error);
//     } finally {
//       if (button) {
//         button.innerHTML = button.dataset.originalHtml || "ADD";
//         if (button instanceof HTMLButtonElement) button.disabled = false;
//       }
//     }
//   }

//   /**
//    * Handle the click on Upsell buttons.
//    */
//   document.addEventListener("click", async (e) => {
//     const btn = e.target.closest('.ooc-drawer-add-btn, .ooc-upsell-add-btn');
//     if (!btn || isProcessing) return;

//     e.preventDefault();
//     e.stopPropagation();
//     isProcessing = true;

//     try {
//       const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
//       const isMember = cart.items.some(it => CLUB_IDS.includes(Number(it.variant_id)) || !!it.selling_plan_allocation);

//       const itemsToAdd = [];
//       const isFromDrawer = btn.classList.contains('ooc-drawer-add-btn');
//       const hasBottleInCart = cart.items.some(it =>
//         (it.handle || '').includes('huilier') ||
//         (it.title || '').toLowerCase().includes('bottle') ||
//         (it.product_id && String(it.product_id) === String(btn.getAttribute('data-product-id')))
//       );

//       // 1. BUNDLE MAIN PRODUCT: Only if the user is not a member yet
//       if (!isMember) {
//         const mainVId = btn.getAttribute('data-main-variant-id');
//         const mainSId = btn.getAttribute('data-main-selling-plan');
//         if (mainVId && mainVId !== "null" && mainVId !== "") {
//           itemsToAdd.push({ id: mainVId, quantity: 1, selling_plan: mainSId });
//         }
//       }

//       // 2. BOTTLE DECISION:
//       // If we are in the cart drawer and already have a bottle, we ONLY add the subscription.
//       // The theme's cart observer will handle updating the existing bottle's price.
//       // If we are on the PDP (Product Page), we ALWAYS add another bottle.
//       let shouldAddAnotherBottle = true;
//       if (isFromDrawer && hasBottleInCart) {
//         shouldAddAnotherBottle = false;
//       }

//       if (shouldAddAnotherBottle) {
//         const willBeMember = isMember || itemsToAdd.some(it => it.selling_plan);
//         const regularId = btn.getAttribute('data-regular-id');
//         const memberId = btn.getAttribute('data-member-id');
//         const targetId = willBeMember ? memberId : regularId;

//         if (targetId && targetId !== "null") {
//           itemsToAdd.push({ id: targetId, quantity: 1 });
//         }
//       }

//       if (itemsToAdd.length > 0) {
//         await performAdd(itemsToAdd, btn);
//       }
//     } finally {
//       isProcessing = false;
//     }
//   }, true);

//   // Initialize UI on load
//   document.addEventListener('DOMContentLoaded', updateUpsellUI);
//   window.addEventListener('load', updateUpsellUI);
//   document.addEventListener('cart:updated', updateUpsellUI);

// })();








// /**
//  * Cantaria — Huilier Upsell UI Logic
//  * Handles bundling of the Ceramic Bottle and Main Subscription product.
//  * Optimized for AJAX cart updates and multiple additions.
//  */

// (function () {
//   const CLUB_IDS = [
//     62474984161629, 62474984227165, 15962089619805, 15962069827933,
//     15962048594269, 15955956695389, 15910818775389, 15910818152797,
//     15908234527069, 15908233511261, 15734454092125, 15728565682525
//   ];

//   let isProcessing = false;

//   /**
//    * Refresh the upsell UI state (hidden/visible classes).
//    */
//   async function updateUpsellUI() {
//     try {
//       const res = await fetch('/cart.js', { cache: 'no-store' });
//       const cart = await res.json();
//       const items = cart.items || [];

//       const hasClub = items.some(it =>
//         CLUB_IDS.includes(Number(it.variant_id)) ||
//         CLUB_IDS.includes(Number(it.id)) ||
//         !!it.selling_plan_allocation
//       );

//       const drawer = document.querySelector('#ooc-drawer-upsell');
//       if (drawer) {
//         const hasBottle = items.some(it => (it.handle || '').includes('huilier') || (it.title || '').toLowerCase().includes('bottle'));

//         drawer.dataset.hasClub = String(hasClub);
//         drawer.dataset.hasDispenser = String(hasBottle);

//         if (hasBottle) {
//           if (!hasClub) {
//             // Suggest club
//             drawer.classList.remove('ooc-hidden');
//             drawer.classList.add('state-add-club');
//             drawer.classList.remove('state-add-product');
//           } else {
//             // Already have both or success state -> hide
//             drawer.classList.add('ooc-hidden');
//           }
//         } else {
//           // No bottle -> Suggest bottle
//           drawer.classList.remove('ooc-hidden');
//           drawer.classList.add('state-add-product');
//           drawer.classList.remove('state-add-club');
//         }
//       }

//       document.querySelectorAll('.ooc-upsell-container').forEach(el => {
//         const hasBottle = items.some(it => (it.handle || '').includes('huilier') || (it.title || '').toLowerCase().includes('bottle'));
//         if (hasBottle) {
//           el.classList.add('ooc-hidden');
//         } else {
//           el.classList.remove('ooc-hidden');
//         }
//         el.classList.toggle('is-member', hasClub);
//       });
//     } catch (e) {
//       console.warn('[Cantaria] UI Sync Error:', e);
//     }
//   }

//   /**
//    * Perform the AJAX addition to the cart and update the drawer.
//    */
//   async function performAdd(itemsToAdd, button) {
//     if (itemsToAdd.length === 0) return;

//     try {
//       if (button) {
//         button.dataset.originalHtml = button.innerHTML;
//         button.innerHTML = "Adding...";
//         if (button instanceof HTMLButtonElement) button.disabled = true;
//       }

//       // Collect all sections that might need refreshing (drawer, count, etc)
//       const sections = Array.from(document.querySelectorAll('[data-section-id]'))
//         .map(el => el.dataset.sectionId)
//         .filter(Boolean)
//         .join(',');

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           items: itemsToAdd,
//           sections: sections,
//           sections_url: window.location.pathname
//         })
//       });

//       const data = await response.json();

//       if (!response.ok) throw new Error(data.message || 'Cart Add Failed');

//       // Dispatch native theme events to refresh the UI and Open Drawer
//       const eventDetail = {
//         bubbles: true,
//         detail: {
//           data: { sections: data.sections },
//           itemCount: data.item_count,
//           source: 'product-form-component'
//         }
//       };

//       document.dispatchEvent(new CustomEvent('cart:update', eventDetail));
//       document.dispatchEvent(new CustomEvent('cart:updated'));

//       // Explicitly show the cart drawer
//       const cartDrawer = document.querySelector('cart-drawer-component');
//       if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
//         cartDrawer.showDialog();
//       }

//       await updateUpsellUI();
//     } catch (error) {
//       console.error('[Cantaria] Upsell Add Failed:', error);
//     } finally {
//       if (button) {
//         button.innerHTML = button.dataset.originalHtml || "ADD";
//         if (button instanceof HTMLButtonElement) button.disabled = false;
//       }
//     }
//   }

//   /**
//    * Handle the click on Upsell buttons.
//    */
//   document.addEventListener("click", async (e) => {
//     const btn = e.target.closest('.ooc-drawer-add-btn, .ooc-upsell-add-btn');
//     if (!btn || isProcessing) return;

//     e.preventDefault();
//     e.stopPropagation();
//     isProcessing = true;

//     try {
//       const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
//       const isMember = cart.items.some(it => CLUB_IDS.includes(Number(it.variant_id)) || !!it.selling_plan_allocation);

//       const itemsToAdd = [];
//       const isFromDrawer = btn.classList.contains('ooc-drawer-add-btn');
//       const hasBottleInCart = cart.items.some(it =>
//         (it.handle || '').includes('huilier') ||
//         (it.title || '').toLowerCase().includes('bottle') ||
//         (it.product_id && String(it.product_id) === String(btn.getAttribute('data-product-id')))
//       );

//       // 1. BUNDLE MAIN PRODUCT: Only if the user is not a member yet
//       if (!isMember) {
//         const mainVId = btn.getAttribute('data-main-variant-id');
//         const mainSId = btn.getAttribute('data-main-selling-plan');
//         if (mainVId && mainVId !== "null" && mainVId !== "") {
//           itemsToAdd.push({ id: mainVId, quantity: 1, selling_plan: mainSId });
//         }
//       }

//       // 2. BOTTLE DECISION:
//       // If we are in the cart drawer and already have a bottle, we ONLY add the subscription.
//       // The theme's cart observer will handle updating the existing bottle's price.
//       // If we are on the PDP (Product Page), we ALWAYS add another bottle.
//       let shouldAddAnotherBottle = true;
//       if (isFromDrawer && hasBottleInCart) {
//         shouldAddAnotherBottle = false;
//       }

//       if (shouldAddAnotherBottle) {
//         const willBeMember = isMember || itemsToAdd.some(it => it.selling_plan);
//         const regularId = btn.getAttribute('data-regular-id');
//         const memberId = btn.getAttribute('data-member-id');
//         const targetId = willBeMember ? memberId : regularId;

//         if (targetId && targetId !== "null") {
//           itemsToAdd.push({ id: targetId, quantity: 1 });
//         }
//       }

//       if (itemsToAdd.length > 0) {
//         await performAdd(itemsToAdd, btn);
//       }
//     } finally {
//       isProcessing = false;
//     }
//   }, true);

//   // Initialize UI on load
//   document.addEventListener('DOMContentLoaded', updateUpsellUI);
//   window.addEventListener('load', updateUpsellUI);
//   document.addEventListener('cart:updated', updateUpsellUI);

// })();




/**
 * Cantaria — Huilier Upsell UI Logic
 * Handles bundling of the Ceramic Bottle and Main Subscription product.
 * Optimized for AJAX cart updates and multiple additions.
 */

(function () {
  const CLUB_IDS = [
    62474984161629, 62474984227165, 15962089619805, 15962069827933,
    15962048594269, 15955956695389, 15910818775389, 15910818152797,
    15908234527069, 15908233511261, 15734454092125, 15728565682525
  ];

  let isProcessing = false;

  /**
   * Refresh the upsell UI state (hidden/visible classes).
   */
  async function updateUpsellUI() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();
      const items = cart.items || [];

const hasClub = items.some(it =>
  !!it.selling_plan_allocation
);

      const drawer = document.querySelector('#ooc-drawer-upsell');
      if (drawer) {
        const dispenserId = String(drawer.dataset.productId || '');
        const hasBottle = items.some(it => String(it.product_id) === dispenserId);

        drawer.dataset.hasClub = String(hasClub);
        drawer.dataset.hasDispenser = String(hasBottle);

        if (hasBottle) {
          if (!hasClub) {
            // Suggest club
            drawer.classList.remove('ooc-hidden');
            drawer.classList.add('state-add-club');
            drawer.classList.remove('state-add-product');
          } else {
            // Already have both -> hide
            drawer.classList.add('ooc-hidden');
          }
        } else {
          // No bottle -> Suggest bottle ONLY IF user has (or is adding) a subscription
          if (hasClub) {
            drawer.classList.remove('ooc-hidden');
            drawer.classList.add('state-add-product');
            drawer.classList.remove('state-add-club');
          } else {
            // Point 2: if they don't have a club, hide the "Add Bottle" suggestion in basket
            drawer.classList.add('ooc-hidden');
          }
        }
      }

document.querySelectorAll('.ooc-upsell-container').forEach(el => {
  const hasBottle = items.some(it =>
    String(it.product_id) === '15889565647197' ||
    (it.handle || '').includes('huilier') ||
    (it.title || '').toLowerCase().includes('bottle')
  );

  if (hasBottle) {
    el.classList.add('ooc-hidden');
  } else {
    el.classList.remove('ooc-hidden');
  }

  el.classList.toggle('is-member', hasClub);
});
    } catch (e) {
      console.warn('[Cantaria] UI Sync Error:', e);
    }
  }

  /**
   * Perform the AJAX addition to the cart and update the drawer.
   */
  async function performAdd(itemsToAdd, button) {
    if (itemsToAdd.length === 0) return;

    try {
      if (button) {
        button.dataset.originalHtml = button.innerHTML;
        button.innerHTML = "Adding...";
        if (button instanceof HTMLButtonElement) button.disabled = true;
      }

      // Collect all sections that might need refreshing (drawer, count, etc)
      const sections = Array.from(document.querySelectorAll('[data-section-id]'))
        .map(el => el.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: itemsToAdd,
          sections: sections,
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || 'Cart Add Failed');

      // Dispatch native theme events to refresh the UI and Open Drawer
      const eventDetail = {
        bubbles: true,
        detail: {
          data: { sections: data.sections },
          itemCount: data.item_count,
          source: 'product-form-component'
        }
      };

      document.dispatchEvent(new CustomEvent('cart:update', eventDetail));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      // Explicitly show the cart drawer
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
      }

      await updateUpsellUI();
    } catch (error) {
      console.error('[Cantaria] Upsell Add Failed:', error);
    } finally {
      if (button) {
        button.innerHTML = button.dataset.originalHtml || "ADD";
        if (button instanceof HTMLButtonElement) button.disabled = false;
      }
    }
  }

  /**
   * Handle the click on Upsell buttons.
   */
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest('.ooc-drawer-add-btn, .ooc-upsell-add-btn');
    if (!btn || isProcessing) return;

    e.preventDefault();
    e.stopPropagation();
    isProcessing = true;

    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
const isMember = cart.items.some(it =>
  !!it.selling_plan_allocation
);
      const itemsToAdd = [];
      const isFromDrawer = btn.classList.contains('ooc-drawer-add-btn');
      const drawer = document.querySelector('#ooc-drawer-upsell');
      const dispenserId = String(drawer?.dataset.productId || btn.getAttribute('data-product-id') || '');
      const hasBottleInCart = cart.items.some(it => String(it.product_id) === dispenserId);

const mainVId = btn.getAttribute('data-main-variant-id');
const mainSId = btn.getAttribute('data-main-selling-plan');
const memberId = btn.getAttribute('data-member-id');
const regularId = btn.getAttribute('data-regular-id');

// 🔹 Cas principal : ajouter l’huilier si absent
if (!hasBottleInCart) {
  const huilierId = isMember ? memberId : regularId;

  if (huilierId && huilierId !== "null" && huilierId !== "") {
    itemsToAdd.push({ id: huilierId, quantity: 1 });
  }
}

// 🔹 Cas secondaire : proposer le club si huilier déjà présent sans abonnement
else if (!isMember && hasBottleInCart) {
  if (
    mainVId && mainVId !== "null" && mainVId !== "" &&
    mainSId && mainSId !== "null" && mainSId !== ""
  ) {
    itemsToAdd.push({ id: mainVId, quantity: 1, selling_plan: mainSId });
  }
}

      if (itemsToAdd.length > 0) {
        await performAdd(itemsToAdd, btn);
      }
    } finally {
      isProcessing = false;
    }
  }, true);

  // Initialize UI on load
  document.addEventListener('DOMContentLoaded', updateUpsellUI);
  window.addEventListener('load', updateUpsellUI);
  document.addEventListener('cart:updated', updateUpsellUI);
  document.addEventListener('cart:update', updateUpsellUI);

})();